import {RRLogisticType} from "../../views/logistics/RRLogisticType";

interface MLogisticsCalendarCellProps {
    day: Date;
    events: RRLogisticType[];
    onClick: () => void;
}

export default function MLogisticsCalendarCell({day, events, onClick}: MLogisticsCalendarCellProps) {
    function getLogisticsClassName(event: RRLogisticType): string {
        if(event.workInStore) {
            return "bg-info text-dark rounded border border-1 fw-bold p-1"
        }

        if(event.reportStartDate) {
            return "bg-secondary text-white rounded border border-1 fw-bold p-1";
        }

        return "bg-warning text-white rounded border border-1 fw-bold p-1";
    }

    function getLogisticsShortName(event: RRLogisticType): string {
        if(event.workInStore) {
            return "Склад";
        }

        return event.eventNumber || event.truck?.plate || event.truck?.name || "";
    }

    return (
        <div className={"d-flex flex-column h-100"}
             onClick={() => {onClick()}}
        >
            <h6>{day.getDate()}</h6>
            {events.map((event, index) =>
                                <div key={event.id}
                                     style={{maxWidth: "35pt", fontSize: "6.5pt", overflow: "hidden"}}
                                     className={getLogisticsClassName(event)}>
                                    {getLogisticsShortName(event)}
                                </div>
                        )
            }
        </div>
    );
}
